























import {
  defineComponent,
  inject,
  watchEffect,
} from '@vue/composition-api';
import AlertMessage from '@/components/atoms/AlertMessage.vue';
import PageBlock from '@/components/atoms/PageBlock.vue';
import VisualPiano from '@/components/organisms/VisualPiano.vue';
import MIDIDeviceStore from '@/stores/MIDIDeviceStore';

export default defineComponent({
  name: 'MainPage',

  components: { AlertMessage, PageBlock, VisualPiano },

  setup() {
    const store = inject(MIDIDeviceStore.key) as MIDIDeviceStore;
    const { state } = store;

    watchEffect((onInvalidate) => {
      store.connect();
      onInvalidate(() => store.disconnect());
    });

    return {
      state,
    };
  },
});
